export default "__VITE_ASSET__CX8hKaz8__"